import React, { useState } from "react";
import styles from "./rectificativa-modal.module.css";
import { MyIcons } from "../../icons/my-icons";
import Button from "../../ui/button";
import { createFacturaRectificativa } from "../../../services/apiService";
import { showSuccessToast, showErrorToast } from "../../../utils/notifications";

const RectificativaModal = ({ isOpen, onClose, documentId, onSuccess }) => {
  const [motivo, setMotivo] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!motivo.trim()) {
      showErrorToast("Por favor, introduzca el motivo de la rectificativa");
      return;
    }

    try {
      setLoading(true);
      await createFacturaRectificativa(documentId, motivo);
      showSuccessToast("Factura rectificativa creada exitosamente");
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error("Error creating rectificativa:", error);
      showErrorToast("Error al crear la factura rectificativa");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Crear Factura Rectificativa</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons name="close" size={24} color="black" />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.inputGroup}>
            <label className={styles.label}>Motivo de la rectificativa</label>
            <textarea
              className={styles.textarea}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder="Escriba el motivo de la rectificativa..."
              rows={6}
              disabled={loading}
              spellCheck="true"
            />
          </div>
        </div>

        <div className={styles.modalFooter}>
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading || !motivo.trim()}
          >
            {loading ? "Creando..." : "Crear Rectificativa"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RectificativaModal;
